import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { FontWeight, Colors } from '../../../assets/styles';

const pxToRem = (px: number): string => `${px / 16}rem`;

const useStyles = makeStyles((theme: Theme) => ({
    input: {
      paddingTop: `${pxToRem(34)} !important`,
      '& label': {
        fontSize: 12,
        letterSpacing: 1.38,
        textTransform: 'uppercase',
      },
    },
    submitButton: {
      maxWidth: 300,
      display: 'block !important',
      margin: `${pxToRem(41)} auto 0 !important`,
    },
    submitButtonSalesForce:{
      maxWidth: 300,
      display: 'block',
      margin: `${pxToRem(20)} auto 0`,
    },
    requestAccessButton: {
      maxWidth: 300,
      display: 'block !important',
      margin: `${pxToRem(15)} auto 0 !important`,
    },
    forgotLinkWrapper: {
      textAlign: 'right',
      paddingTop: pxToRem(14),
    },
    forgotLink: {
      fontSize: pxToRem(15),
    },
    error: {
      fontSize: pxToRem(15),
      fontWeight: FontWeight.Regular,
      color: `${Colors.Red} !important`,
      paddingTop: pxToRem(20),
    },
  }))

  export default useStyles;